import React, { useEffect, useRef } from "react";
import { inject, observer } from "mobx-react";
import lottie from 'lottie-web';
import classnames from 'classnames';
// import RTCInstanceModal from '@/models/rtc';
import Style from './index.less';
import { useIntl } from "umi";

interface ReconnectProps {
  // rtc?: RTCInstanceModal;
  show: boolean;
}

const Reconnect: React.FC<ReconnectProps> = inject(({ }) => {
  return {
    // rtc: store.rtc,
  };
})(
  observer(props => {
    const { show } = props;
    const reconnectingRef = useRef<HTMLDivElement>(null);
    const { formatMessage } = useIntl();

    useEffect(() => {
      if (reconnectingRef && reconnectingRef.current) {
        lottie.loadAnimation({
          container: reconnectingRef.current, // the dom element that will contain the animation
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: `${process.env.NODE_ENV === 'production' ? '/meet/' : '/'}json/break-line-reconnecting.json`,
        });
      }
    }, [reconnectingRef]);

    return (
      <div className={classnames(Style['view-panel-wrap'], Style.reconnect, !show ? Style.hidden : undefined)}>
        <div ref={reconnectingRef} style={{ height: 56, width: 56 }} />
        <div className={Style.unstable}>
          {formatMessage({ id: 'UNSTABLE_CONNECTION' })}
        </div>
        <div className={Style.reconnecting}>
          {formatMessage({ id: 'TRYING_TO_RECONNECT' })}
        </div>
      </div>
    );
  })
);

export default Reconnect;
